import type { SVGProps } from "react";
import React from "react";

export const BasketIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  fill = "#000",
  width = 20,
  height = 20,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.375 5.52474C16.3708 5.41637 16.3252 5.31371 16.2478 5.2378C16.1703 5.16188 16.0668 5.11846 15.9583 5.11641H12.9C12.8389 4.56544 12.6537 4.03549 12.3583 3.56641C12.1083 3.17172 11.7586 2.8499 11.3446 2.63337C10.9306 2.41685 10.4668 2.31327 9.99999 2.33308C9.53318 2.31327 9.0694 2.41685 8.65537 2.63337C8.24134 2.8499 7.89169 3.17172 7.64166 3.56641C7.34625 4.03549 7.16105 4.56544 7.09999 5.11641H4.04165C3.93321 5.11846 3.82966 5.16188 3.75219 5.2378C3.67473 5.31371 3.62922 5.41637 3.62499 5.52474L3.16665 17.1914C3.163 17.2475 3.17071 17.3037 3.18933 17.3566C3.20795 17.4096 3.23708 17.4583 3.27499 17.4997C3.35892 17.5779 3.46868 17.6224 3.58332 17.6247H16.4167C16.5293 17.6245 16.6372 17.5795 16.7167 17.4997C16.7569 17.4596 16.7881 17.4113 16.8082 17.3582C16.8283 17.305 16.8369 17.2481 16.8333 17.1914L16.375 5.52474ZM7.94166 5.11641C7.99459 4.72918 8.12801 4.35731 8.33332 4.02474C8.51193 3.75018 8.76052 3.52822 9.05348 3.38174C9.34645 3.23526 9.67318 3.16956 9.99999 3.19141C10.3268 3.16956 10.6535 3.23526 10.9465 3.38174C11.2395 3.52822 11.4881 3.75018 11.6667 4.02474C11.8749 4.35664 12.0112 4.72854 12.0667 5.11641H7.94166ZM4.01665 16.7831L4.44165 5.94974H15.5583L15.9833 16.7831H4.01665Z"
      fill={fill}
    />
  </svg>
);
